export default __webpack_public_path__ + "static/media/mada.3e51f7c6.svg";